import React, { forwardRef, useMemo } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Accordion } from 'react-accessible-accordion';
import { sortBy, uniq } from 'lodash';

import { StaticImage } from 'gatsby-plugin-image';

import {
  Section,
  SpecContainer,
  Specs,
  ProductDetailWrapper,
  ProductDetailHeading,
  ProductDetail,
  SpecAccordionItem,
  SpecificationTitleWrapper,
  SpecificationTitle,
  ItemPanel,
  DataWrapper,
  SpecName,
  SpecValue,
  ChevronImage,
} from './styles';

interface SpecSectionProps {
  specLabels: unknown[];
  specifications: unknown[];
  // eslint-disable-next-line react/require-default-props
  headingBody?: string;
}

const SpecSection = forwardRef<HTMLElement, SpecSectionProps>(
  ({ specLabels, specifications, headingBody }, ref) => {
    // Creating list of unique sepc names with "Others" spec name placed at the end of the list
    const groupNames = useMemo(() => sortBy(
      uniq(specifications.map(({ groupName }) => groupName.value)),
      (item) => (item.match(/other/i) ? 1 : 0),
    ), [specifications]);

    if (!specifications.length && !headingBody) return null;

    return (
      (
        <Section id={specLabels?.[0]?.fieldName} ref={ref}>
          <SpecContainer>
            <Specs>
              {/** Product Details */}
              <ProductDetailWrapper>
                <ProductDetailHeading>
                  {specLabels[0].displayLabel}
                </ProductDetailHeading>
                {headingBody && (
                  <ProductDetail>
                    {ReactHtmlParser(headingBody.replace(/<p>(&nbsp;)+<\/p>/g, ''))}
                  </ProductDetail>
                )}
              </ProductDetailWrapper>

              {/** Spec Accordions */}
              <Accordion allowMultipleExpanded allowZeroExpanded>
                {groupNames.map((name) => (
                  <SpecAccordionItem key={name}>
                    <SpecificationTitleWrapper>
                      <SpecificationTitle>
                        {name}
                        <ChevronImage>
                          <StaticImage src="../../../images/chevron-down-black.svg" alt="" className="chevron" />
                        </ChevronImage>
                      </SpecificationTitle>
                    </SpecificationTitleWrapper>
                    <ItemPanel>
                      {specifications
                        .filter(({ groupName }) => groupName.value === name)
                        .map((item) => (
                          <DataWrapper key={item.groupItemName.value}>
                            <SpecName>{item.groupItemName.value}</SpecName>
                            <SpecValue>
                              {ReactHtmlParser(
                                item.value.value
                                  .replace(/\n+/g, '<br><br>')
                                  .replace(/^<br[\s/]*>/, '')
                                  .replace(/<br[\s/]*>$/, '')
                                  .replace(/<br[\s/]*>{3,}/, '<br><br>'),
                              )}
                              {' '}
                              {item?.unit?.value}
                            </SpecValue>
                          </DataWrapper>
                        ))}
                    </ItemPanel>
                  </SpecAccordionItem>
                ))}
              </Accordion>
            </Specs>
          </SpecContainer>
        </Section>
      )
    );
  },
);

export default SpecSection;
